// src/api/stripe.ts
import { apiGet, apiPost } from "./client";

export type StripeConfig = {
  publishableKey: string;
  connectClientId: string;
  // optional flags (backend may or may not send them)
  liveMode?: boolean;
  webhookConfigured?: boolean;
};

export type StripeStatus = {
  connected: boolean;
  account_id?: string | null;
  charges_enabled?: boolean;
  payouts_enabled?: boolean;     // backend may return this
  details_submitted?: boolean;
  connect_account_id?: string | null; // kept for backward compatibility
};

export function getStripeConfig(): Promise<StripeConfig> {
  // If you still use this anywhere, ensure your server has a GET /stripe/config;
  // otherwise consider removing it. Left untouched for compatibility.
  return apiGet<StripeConfig>("/stripe/config");
}

// 🔧 FIX: point to the actual backend route
export function getStripeStatus(): Promise<StripeStatus> {
  return apiGet<StripeStatus>("/stripe/status");
}

export function deauthStripe(): Promise<{ connected: false }> {
  return apiPost<{ connected: false }>("/stripe/connect/deauth", {});
}

export function bootstrapStripeMethods(payload?: {
  methods?: Array<"card" | "alipay" | "wechat_pay">;
  account_id?: number | null;
  fee_rate?: number | null;
  fixed_fee?: number | null;
}) {
  return apiPost("/stripe/connect/bootstrap-methods", payload ?? { methods: ["card"] });
}
